import { render, staticRenderFns } from "./MediaGoogle.vue?vue&type=template&id=9ca2cb18&scoped=true&"
import script from "./MediaGoogle.vue?vue&type=script&lang=js&"
export * from "./MediaGoogle.vue?vue&type=script&lang=js&"
import style0 from "./MediaGoogle.vue?vue&type=style&index=0&id=9ca2cb18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca2cb18",
  null
  
)

export default component.exports